
import { Button, Container } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { Modal } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

const UnitDisplay = (props) => {

    const [edit, setEdit] = useState(false);

    let nameJsx = <h3>{props.obj.name}</h3>


    const editUnitName = (newVal) => {

        if(newVal==props.obj.name) {
            return;
        }
        let newObj = { ...props.obj };
        newObj.name = newVal;
        props.editFunction(props.index, newObj);
        setEdit(false);
    }




    const deleteUnit = () => {
        props.deleteFunction(props.index);
    }
    

    const handleEdit = () => {
        setEdit(prev=> !prev);
        console.log(props.obj);
    }

    return (
        <>
        <Container className="border mb-3">
            <Row className="">
                <Col xs={8}>
                    <NameComponent nameVal={props.obj.name} edit={edit} handleEdit={editUnitName} />
                </Col>
                <Col xs={4}>
                    <Button onClick={handleEdit} value="Rediger">Rediger</Button>
                    <Button onClick={deleteUnit} value="Slet enhed">Slet </Button>
                </Col>
            </Row>
        </Container>

        </>
        
    );

}


const NameComponent = (props) => {
    const [name, setName] = useState(props.nameVal);
    const [edit, setEdit] = useState(props.edit)

    
    useEffect(() => {
        setName(props.nameVal);
        setEdit(props.edit)
    }, [props.edit, props.nameVal])

    const updateUnit = (val) => {
        props.handleEdit(val)
    }
    
    if(edit) {
        return <input
        defaultValue={name}
        onChange={e => setName(e.target.value)}
        onBlur={e => updateUnit(e.target.value)}
        />
    }

    return <p>{props.nameVal}</p>
}


export default UnitDisplay;